import Papa from 'papaparse';
import { SHEET_BEER_COLUMNS, SHEET_BEER_COLUMN_SET } from './sheetColumns';

function trimCell(value) {
  const trimmed = typeof value === 'string' ? value.trim() : String(value ?? '').trim();
  return trimmed.replace(/^\uFEFF/, '');
}

function isBlankRow(row) {
  return SHEET_BEER_COLUMNS.every((column) => !trimCell(row[column]));
}

function validateHeaders(fields) {
  if (!Array.isArray(fields) || fields.length === 0) {
    return 'CSV must include a header row';
  }

  const missing = SHEET_BEER_COLUMNS.filter((column) => !fields.includes(column));
  if (missing.length > 0) {
    return `Missing required columns: ${missing.join(', ')}`;
  }

  const unexpected = fields.filter((field) => field && !SHEET_BEER_COLUMN_SET.has(field));
  if (unexpected.length > 0) {
    return `Unexpected columns: ${unexpected.join(', ')}`;
  }

  return null;
}

/**
 * Parses a beer import CSV string into normalized row objects.
 */
export function parseSheetCsv(csvText) {
  if (typeof csvText !== 'string' || !csvText.trim()) {
    return { rows: [], headerError: 'CSV file is empty', parseError: null };
  }

  const parsed = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => trimCell(header),
  });

  if (parsed.errors?.length) {
    const firstError = parsed.errors[0];
    return {
      rows: [],
      headerError: null,
      parseError: firstError.message || 'Failed to parse CSV',
    };
  }

  const headerError = validateHeaders(parsed.meta?.fields);
  if (headerError) {
    return { rows: [], headerError, parseError: null };
  }

  const rows = (parsed.data ?? [])
    .filter((row) => !isBlankRow(row))
    .map((row, index) => ({
      rowIndex: index,
      breweryName: trimCell(row.breweryName),
      state: trimCell(row.state),
      beerName: trimCell(row.beerName),
      styleLabel: trimCell(row.styleLabel),
      abv: trimCell(row.abv),
      styleType: trimCell(row.styleType),
    }));

  return { rows, headerError: null, parseError: null };
}
